<template>

</template>

<script>
 import md5 from 'js-md5';

export default {
  name: 'DevicePoC23',
  props: {

  },
  data(){
    return {

    }
  },
  methods:{
    getAddUserRecords(formData) {
      console.log('DevicePoC23 getAddUserRecords');
      console.log('formData:', formData);

      const { returnObj } = formData;

      returnObj['vpnid'] = formData.vpnid;

      if(formData.username) {
        returnObj['username'] = formData.username;
      }

      returnObj['createtime'] = Math.round(new Date() / 1000);

      if(returnObj['regclass'] === 0){
        returnObj['regclass'] = 1;
      }
      else if(returnObj['regclass'] === 1){
        returnObj['regclass'] = 3;
      }

      let voiceClassName      = 'voiceClass';
      let dataClassName       = 'dataClass';
      let mediaClassName      = 'mediaClass';
      let otherClassName      = 'otherClass';

      let voicestror = "000000000"+returnObj[voiceClassName].toString(2);
      let datastror  = "0000"+returnObj[dataClassName].toString(2);
      let mediastror = "0000000000000000"+returnObj[mediaClassName].toString(2);
      let otherstror = "00000000000000000"+returnObj[otherClassName].toString(2);

      let voicestr = voicestror.split('').reverse().join('');
      let datastr  = datastror.split('').reverse().join('');
      let mediastr = mediastror.split('').reverse().join('');
      let otherstr = otherstror.split('').reverse().join('');

      let voice = voicestr.charAt(0)+voicestr.charAt(1)+voicestr.charAt(2);
      let data  = datastr.charAt(0)+datastr.charAt(1)+datastr.charAt(2)+datastr.charAt(3)+mediastr.charAt(14)+mediastr.charAt(15);
      //�����Ƶĵ���λ�ǡ���Ƶ�ش�����Ϊ�˽��δlic�Զ���ֵ���⡣
      if(returnObj['rtttype'] === 4) {//˫ģ�ն�ȡ������Ƶ�ش�Ȩ�ޡ�--2021-06-09 ���td-2709
        mediastr = mediastr.substr(0, 5) + "0"+ mediastr.substr(6, mediastr.length-5);
      }
      let media = mediastr.charAt(0)+mediastr.charAt(1)+mediastr.charAt(2)+mediastr.charAt(3)+mediastr.charAt(4)+mediastr.charAt(5)+mediastr.charAt(6)+mediastr.charAt(7)+mediastr.charAt(8)+mediastr.charAt(9)+mediastr.charAt(10)+mediastr.charAt(11);
      let other = voicestr.charAt(3)+voicestr.charAt(4)+otherstr.charAt(0)+otherstr.charAt(1)+'0'+otherstr.charAt(2)+otherstr.charAt(3)+otherstr.charAt(4)+otherstr.charAt(5)+otherstr.charAt(6)+voicestr.charAt(5)+otherstr.charAt(7)+otherstr.charAt(8)+voicestr.charAt(6)+
        voicestr.charAt(7)+mediastr.charAt(12)+otherstr.charAt(9)+otherstr.charAt(10)+otherstr.charAt(11)+voicestr.charAt(8)+mediastr.charAt(13)+otherstr.charAt(12)+otherstr.charAt(13)+otherstr.charAt(14)+otherstr.charAt(15);

      returnObj[voiceClassName] = parseInt(voice.split('').reverse().join(''),2);
      returnObj[dataClassName]  = parseInt(data.split('').reverse().join(''),2);
      returnObj[mediaClassName] = parseInt(media.split('').reverse().join(''),2);
      returnObj[otherClassName] = parseInt(other.split('').reverse().join(''),2);

      if(formData.opCode ==='mod')
      {
        if(formData.passwordbefore != returnObj['password[confirm]'] || formData.realmbefore != returnObj['realm'] || formData.lteimsibefore != returnObj['lteimsi'])
        {
          if(returnObj['lteimsi']!=='')
            returnObj['password'] = md5(returnObj['impu']+':'+returnObj['realm'].replace('@','')+':'+returnObj['password[confirm]']+':'+returnObj['lteimsi']);
          else
            returnObj['password'] = md5(returnObj['impu']+':'+returnObj['realm'].replace('@','')+':'+returnObj['password[confirm]']);
        }
        else
        {
          returnObj['password'] = formData.passwordbefore;
        }
      }

      if(formData.opCode ==='add' || formData.opCode ==='mod') {
        returnObj.opCount = 1;
      }

      return returnObj;
    },
    getModUserRecords(param, recordData) {
      console.log('DevicePoC23 getModUserRecords:',param, recordData);

      const record = JSON.parse(JSON.stringify(recordData));

      if(record['regclass'] === 1){
        record['regclass'] = 0;
      }
      else if(record['regclass'] === 3){
        record['regclass'] = 1;
      }

      let voiceClassName      = 'voiceClass';
      let dataClassName       = 'dataClass';
      let mediaClassName      = 'mediaClass';
      let otherClassName      = 'otherClass';

      let voicestror = "000"+record[voiceClassName].toString(2);
      let datastror  = "000000"+record[dataClassName].toString(2);
      let mediastror = "000000000000"+record[mediaClassName].toString(2);
      let otherstror = "0000000000000000000000000"+record[otherClassName].toString(2);

      voicestror = voicestror.substring(voicestror.length-3);
      datastror = datastror.substring(datastror.length-6);
      mediastror = mediastror.substring(mediastror.length-12);
      otherstror = otherstror.substring(otherstror.length-25);

      let voicestr = voicestror.split('').reverse().join('');
      let datastr = datastror.split('').reverse().join('');
      let mediastr = mediastror.split('').reverse().join('');
      let otherstr = otherstror.split('').reverse().join('');
      //�����Ƶĵ���λ�ǡ���Ƶ�ش�����Ϊ�˽��δlic�Զ���ֵ���⡣
      if(record['rtttype'] === 4) {//˫ģ�ն�ȡ������Ƶ�ش�Ȩ�ޡ�--2021-06-09 ���td-2709
        mediastr = mediastr.substr(0, 5) + "0"+ mediastr.substr(6, mediastr.length-5);
      }
      let voice=[];
      let data=[];
      let media=[];
      let other=[];
      voice[0] = voicestr.charAt(0);
      voice[1] = voicestr.charAt(1);
      voice[2] = voicestr.charAt(2);

      data[0] = datastr.charAt(0);
      data[1] = datastr.charAt(1);
      data[2] = datastr.charAt(2);
      data[3] = datastr.charAt(3);
      media[14] = datastr.charAt(4);
      media[15] = datastr.charAt(5);

      media[0] = mediastr.charAt(0);
      media[1] = mediastr.charAt(1);
      media[2] = mediastr.charAt(2);
      media[3] = mediastr.charAt(3);
      media[4] = mediastr.charAt(4);
      media[5] = mediastr.charAt(5);
      media[6] = mediastr.charAt(6);
      media[7] = mediastr.charAt(7);
      media[8] = mediastr.charAt(8);
      media[9] = mediastr.charAt(9);
      media[10] = mediastr.charAt(10);
      media[11] = mediastr.charAt(11);

      voice[3] = otherstr.charAt(0);
      voice[4] = otherstr.charAt(1);
      other[0] = otherstr.charAt(2);
      other[1] = otherstr.charAt(3);
      other[2] = otherstr.charAt(5);
      other[3] = otherstr.charAt(6);
      other[4] = otherstr.charAt(7);
      other[5] = otherstr.charAt(8);
      other[6] = otherstr.charAt(9);
      voice[5] = otherstr.charAt(10);
      other[7] = otherstr.charAt(11);
      other[8] = otherstr.charAt(12);
      voice[6] = otherstr.charAt(13);
      voice[7] = otherstr.charAt(14);
      media[12] = otherstr.charAt(15);
      other[9] = otherstr.charAt(16);
      other[10] = otherstr.charAt(17);
      other[11] = otherstr.charAt(18);
      voice[8] = otherstr.charAt(19);
      media[13] = otherstr.charAt(20);
      other[12] = otherstr.charAt(21);
      other[13] = otherstr.charAt(22);
      other[14] = otherstr.charAt(23);
      other[15] = otherstr.charAt(24);

      let voiceclass ='';
      voice.forEach( item => {
        voiceclass = voiceclass + item;
      });
      let dataclass ='';
      data.forEach( item => {
        dataclass =dataclass+item;
      });
      let mediaclass ='';
      media.forEach( item => {
        mediaclass = mediaclass + item;
      });
      let otherclass ='';
      other.forEach( item => {
        otherclass = otherclass + item;
      });

      record[voiceClassName] = parseInt(voiceclass.split('').reverse().join(''),2);
      record[dataClassName] = parseInt(dataclass.split('').reverse().join(''),2);
      record[mediaClassName] = parseInt(mediaclass.split('').reverse().join(''),2);
      record[otherClassName] = parseInt(otherclass.split('').reverse().join(''),2);

      record['password[origin]'] = record['password'];
      record['password[confirm]'] = record['password'];

      return record;
    },
    getQryUserRecords(param) {
      console.log('DevicePoC23 getQryUserRecords:',param);
      // nothing to do
      return null;
    },
    getDelUserRecords(param) {
      console.log('DevicePoC23 getDelUserRecords:', param);

      const { userid, info } = param;

      const users = [];
      const resultObj = [];
      for (let i = 0; i < userid.length; i++) {
        users.push(userid[i].impu);
        resultObj[i] = { operObj: userid[i].impu };
      }

      const logParam = {
        module: 'res.subscriber#res.subscriber_ims#subscriber.imsUser',
        execFunName:'subscriber.delUser',
        exectype:3,
        execData:users
      };

      const paramMap = {};
      paramMap.vo   = { opCount: users.length, impu: users };
      paramMap.log  = logParam;
      paramMap.info = info;

      return { paramMap, resultObj };
    },
    getBatchModUserRecords(param, recordData) {
      console.log('DevicePoC23 getBatchModUserRecords:',param, recordData);
      return recordData;
    },
  },
  components:{

  }
}
</script>
